// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDfdKexK4kTp2mGgceuYTJgsS4_4ba9XOo",
    authDomain: "routechef-b1c5f.firebaseapp.com",
    projectId: "routechef-b1c5f",
    storageBucket: "routechef-b1c5f.appspot.com",
    messagingSenderId: "863459882866",
    appId: "1:863459882866:web:a224e5dcfb66a13ab48feb",
    measurementId: "G-V9KMLS73T7",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);